import {
  SETTING_BANK_ACCOUNT_PAGE_REQUEST,
  SETTING_BANK_ACCOUNT_ADD_NEW_BANK,
  SETTING_BANK_ACCOUNT_SET_BANK_LIST,
  SETTING_BANK_ACCOUNT_SET_OUTLETS,
  SETTING_BANK_ACCOUNT_SET_OUTLET_STATUS,
  SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_LISTS,
  SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_DETAIL,
  SETTING_BANK_ACCOUNT_SET_UNLINK_OUTLETS,
  SETTING_BANK_ACCOUNT_SET_PAYMENT_METHODS,
  SETTING_BANK_ACCOUNT_SET_ERRORS,
  SETTING_BANK_ACCOUNT_SET_AVAILABLE_OUTLETS,
  SETTING_BANK_ACCOUNT_SET_PROFILE,
  SETTING_BANK_ACCOUNT_SET_OTP,
  SETTING_BANK_ACCOUNT_SET_ACTIVITY_LOGS,
  SETTING_BANK_ACCOUNT_SET_SELECTED_ACTIVITY_LOG,
  SETTING_BANK_ACCOUNT_SET_SEARCH_BANK_ACCOUNTS,
  SETTING_BANK_ACCOUNT_SET_HAS_MORE_ACTIVITY_LOGS,
  SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET,
  SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET_MODAL,
  SETTING_BANK_ACCOUNT_SHOW_LOADING_SPINNER_MODAL,
  SETTING_BANK_ACCOUNT_HIDE_LOADING_SPINNER_MODAL,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_SAVE_ALL,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_SAVE_ALL,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_CHANGES,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_CHANGES,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_ASSIGN_OUTLETS,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_DELETE,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_DELETE,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_PHONE,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_PHONE,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_OTP,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_OTP,
  SETTING_BANK_ACCOUNT_SHOW_MODAL_ACTIVITY_LOG,
  SETTING_BANK_ACCOUNT_HIDE_MODAL_ACTIVITY_LOG,
  SETTING_BANK_ACCOUNT_SHOW_ACTIVITY_LOG_DETAIL,
  SETTING_BANK_ACCOUNT_HIDE_ACTIVITY_LOG_DETAIL,
  SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_ADD_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_MODAL_ASSIGN_OUTLET,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_ROW_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK_V2,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK_V2,
  SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK_V2,
  SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ASSIGN_OUTLETS_MODAL,
  SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ACTIVITY_LOG_MODAL,
  SETTING_BANK_ACCOUNT_ON_CLICK_DELETE_BANK,
  SETTING_BANK_ACCOUNT_ON_CLICK_SEND_OTP,
  SETTING_BANK_ACCOUNT_ON_CHANGE_VERIFY_OTP,
  SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_KEYWORD,
  SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_BANK_ACCOUNTS,
  SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_AVAILABLE_OUTLETS,
  SETTING_BANK_ACCOUNT_ON_LOAD_ACTIVITY_LOGS,
  SETTING_BANK_ACCOUNT_SHOW_RIGHT_COLUMN,
  SETTING_BANK_ACCOUNT_HIDE_RIGHT_COLUMN,
} from './constants';

export function bankAccountPageRequest() {
  return { type: SETTING_BANK_ACCOUNT_PAGE_REQUEST, payload: {} };
}

export function addNewBank() {
  return { type: SETTING_BANK_ACCOUNT_ADD_NEW_BANK, payload: {} };
}

export function addOutletstoBankForm(outletList, unlinkOutlets) {
  return {
    type: SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET,
    payload: { outletList, unlinkOutlets },
  };
}

export function setSelectedOutletsModal(outletList) {
  return {
    type: SETTING_BANK_ACCOUNT_ADD_ASSIGN_OUTLET_MODAL,
    payload: { outletList },
  };
}

export function setBankList(bankList) {
  return { type: SETTING_BANK_ACCOUNT_SET_BANK_LIST, payload: { bankList } };
}

export function setOutlets(outlets) {
  return { type: SETTING_BANK_ACCOUNT_SET_OUTLETS, payload: { outlets } };
}

export function setOutletStatus(outletStatus) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_OUTLET_STATUS,
    payload: { outletStatus },
  };
}

export function setBankAccountLists(bankAccountLists) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_LISTS,
    payload: { bankAccountLists },
  };
}

export function setBankAccountDetail(bankAccount) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_BANK_ACCOUNT_DETAIL,
    payload: { bankAccount },
  };
}

export function setUnlinkOutlets(outletList) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_UNLINK_OUTLETS,
    payload: { outletList },
  };
}

export function setPaymentMethods(paymentMethods) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_PAYMENT_METHODS,
    payload: { paymentMethods },
  };
}

export function setErrors(errors) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_ERRORS,
    payload: { errors },
  };
}

export function setAvailableOutlets(availableOutlets) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_AVAILABLE_OUTLETS,
    payload: { availableOutlets },
  };
}

export function setProfile(profile) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_PROFILE,
    payload: { profile },
  };
}

export function setOtp(otp) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_OTP,
    payload: { otp },
  };
}

export function setActivityLogs(activityLogs) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_ACTIVITY_LOGS,
    payload: { activityLogs },
  };
}

export function setSelectedActivityLog(activityLog) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_SELECTED_ACTIVITY_LOG,
    payload: { activityLog },
  };
}

export function setSearchBankAccounts(bankAccounts) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_SEARCH_BANK_ACCOUNTS,
    payload: { bankAccounts },
  };
}

export function setHasMoreActivityLogs(hasMoreActivityLogs) {
  return {
    type: SETTING_BANK_ACCOUNT_SET_HAS_MORE_ACTIVITY_LOGS,
    payload: { hasMoreActivityLogs },
  };
}

export function showLoadingSpinnerModal() {
  return { type: SETTING_BANK_ACCOUNT_SHOW_LOADING_SPINNER_MODAL, payload: {} };
}

export function hideLoadingSpinnerModal() {
  return { type: SETTING_BANK_ACCOUNT_HIDE_LOADING_SPINNER_MODAL, payload: {} };
}

export function showModalAssignOutlets() {
  return { type: SETTING_BANK_ACCOUNT_SHOW_MODAL_ASSIGN_OUTLETS, payload: {} };
}

export function hideModalAssignOutlets() {
  return { type: SETTING_BANK_ACCOUNT_HIDE_MODAL_ASSIGN_OUTLETS, payload: {} };
}

export function showModalConfirmSaveAll() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_SAVE_ALL,
    payload: {},
  };
}

export function hideModalConfirmSaveAll() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_SAVE_ALL,
    payload: {},
  };
}

export function showModalConfirmChanges() {
  return { type: SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_CHANGES, payload: {} };
}

export function hideModalConfirmChanges() {
  return { type: SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_CHANGES, payload: {} };
}

export function showModalConfirmAssignOutlets() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_MODAL_CONFIRM_ASSIGN_OUTLETS,
    payload: {},
  };
}

export function hideModalConfirmAssignOutlets() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_MODAL_CONFIRM_ASSIGN_OUTLETS,
    payload: {},
  };
}

export function showModalDelete() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_MODAL_DELETE,
    payload: {},
  };
}

export function hideModalDelete() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_MODAL_DELETE,
    payload: {},
  };
}

export function showModalVerifyPhone() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_PHONE,
    payload: {},
  };
}

export function hideModalVerifyPhone() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_PHONE,
    payload: {},
  };
}

export function showModalVerifyOtp() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_MODAL_VERIFY_OTP,
    payload: {},
  };
}

export function hideModalVerifyOtp() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_MODAL_VERIFY_OTP,
    payload: {},
  };
}

export function showModalActivityLog() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_MODAL_ACTIVITY_LOG,
    payload: {},
  };
}

export function hideModalActivityLog() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_MODAL_ACTIVITY_LOG,
    payload: {},
  };
}

export function showActivityLogDetail() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_ACTIVITY_LOG_DETAIL,
    payload: {},
  };
}

export function hideActivityLogDetail() {
  return {
    type: SETTING_BANK_ACCOUNT_HIDE_ACTIVITY_LOG_DETAIL,
    payload: {},
  };
}

export function showRightColumnAsForm() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_RIGHT_COLUMN,
    payload: { rightColumnType: 'form' },
  };
}

export function showRightColumnAsEdit() {
  return {
    type: SETTING_BANK_ACCOUNT_SHOW_RIGHT_COLUMN,
    payload: { rightColumnType: 'edit' },
  };
}

export function hideRightColumn() {
  return { type: SETTING_BANK_ACCOUNT_HIDE_RIGHT_COLUMN, payload: {} };
}

export function onClickAddBank(businessId) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK,
    payload: { businessId },
  };
}

export function onClickCancelAddBank() {
  return { type: SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_ADD_BANK, payload: {} };
}

export function onClickCancelModalAssignOutlet() {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_CANCEL_MODAL_ASSIGN_OUTLET,
    payload: {},
  };
}

export function onClickSaveBank(bank) {
  return { type: SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK, payload: { bank } };
}

export function onClickSaveUpdateBank(bank) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK,
    payload: { bank },
  };
}

export function onClickRowBank(bank) {
  return { type: SETTING_BANK_ACCOUNT_ON_CLICK_ROW_BANK, payload: { bank } };
}

export function onChangeKeyword(keyword) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_KEYWORD,
    payload: { keyword },
  };
}

export function onClickAddBankV2() {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_ADD_BANK_V2,
    payload: {},
  };
}

export function onClickSaveBankV2(bankAccount, profile) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_BANK_V2,
    payload: { bankAccount, profile },
  };
}

export function onClickSaveUpdateBankV2(bankAccount, profile) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_SAVE_UPDATE_BANK_V2,
    payload: { bankAccount, profile },
  };
}

export function onClickDeleteBank(bankAccount, profile) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_DELETE_BANK,
    payload: { bankAccount, profile },
  };
}

export function onClickOpenAssignOutletsModal(
  bankAccountId,
  outlets,
  bankAccounts,
  banks,
  selectedOutlets
) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ASSIGN_OUTLETS_MODAL,
    payload: { bankAccountId, outlets, bankAccounts, banks, selectedOutlets },
  };
}

export function onClickOpenActivityLogModal() {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_OPEN_ACTIVITY_LOG_MODAL,
    payload: {},
  };
}

export function onClickSendOtp(phoneNumber) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CLICK_SEND_OTP,
    payload: { phoneNumber },
  };
}

export function onChangeVerifyOtp(
  otp,
  code,
  bankAccount,
  rightColumnType,
  profile
) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CHANGE_VERIFY_OTP,
    payload: { otp, code, bankAccount, rightColumnType, profile },
  };
}

export function onChangeSearchBankAccounts(
  query,
  bankAccounts,
  banks,
  outlets
) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_BANK_ACCOUNTS,
    payload: { query, bankAccounts, banks, outlets },
  };
}

export function onChangeSearchAvailableOutlets(
  query,
  bankAccountId,
  outlets,
  bankAccounts,
  banks
) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_CHANGE_SEARCH_AVAILABLE_OUTLETS,
    payload: { query, bankAccountId, outlets, bankAccounts, banks },
  };
}

export function onLoadActivityLogs(loadedActivityLogs) {
  return {
    type: SETTING_BANK_ACCOUNT_ON_LOAD_ACTIVITY_LOGS,
    payload: { loadedActivityLogs },
  };
}
